const directoryTypes = {
  SET_DIRECTORY_DATA: "DIRECTORY_SET_DIRECTORY_DATA",
  LOADING_DIRECTORY_DATA:"LOADING_DIRECTORY_DATA",
  CLEAR_DIRECTORY:"CLEAR_DIRECTORY",
  ADD_TOTAL_ITEMS:"ADD_TOTAL_ITEMS"
};

export default directoryTypes;
